import lax from 'lax.js';

window.onload = function() {
	if (!window.requestAnimationFrame) {
		return;
	}

	if (document.body.classList.contains('home') || document.body.classList.contains('post-type-archive-service')) {
		lax.setup({
			breakpoints: { large: 992 }
		}); // init

		const updateLax = () => {
			lax.update(window.scrollY);
			window.requestAnimationFrame(updateLax);
		};

		window.requestAnimationFrame(updateLax);

		window.addEventListener('resize', function() {
			lax.updateElements();
		});
	}
};
